import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ServerStatusPayload } from "../../shared/interfaces/ServerStatusPayload";
import { StudentFeeAllocationResponseDto } from "../../shared/dtos/studentFeeAllocation/StudentFeeAllocationResponseDto";
import { PaginationDto } from "../../shared/dtos/common/PaginationDto";

export interface FeeAllocationState {
  loadingFeeAllocations: boolean;
  loadingFeeAllocationCreate: boolean;
  loadingFeeAllocationDelete: boolean;
  errorLoadingFeeAllocations: string | null;
  errorCreatingFeeAllocation: string | null;
  errorDeletingFeeAllocation: string | null;
  feeAllocations: StudentFeeAllocationResponseDto[];
  serverStatus: ServerStatusPayload | null;
  pagination: PaginationDto | null;
}

const initialState: FeeAllocationState = {
  loadingFeeAllocations: false,
  loadingFeeAllocationCreate: false,
  loadingFeeAllocationDelete: false,
  errorLoadingFeeAllocations: null,
  errorCreatingFeeAllocation: null,
  errorDeletingFeeAllocation: null,
  feeAllocations: [],
  serverStatus: null,
  pagination: null,
};

export const feeAllocationSlice = createSlice({
  name: "feeAllocation",
  initialState,
  reducers: {
    setLoadingFeeAllocations: (state) => {
      state.loadingFeeAllocations = true;
      state.errorLoadingFeeAllocations = null;
    },
    setLoadingFeeAllocationCreate: (state) => {
      state.loadingFeeAllocationCreate = true;
      state.errorCreatingFeeAllocation = null;
    },
    setLoadingFeeAllocationDelete: (state) => {
      state.loadingFeeAllocationDelete = true;
      state.errorDeletingFeeAllocation = null;
    },
    setErrorLoadingFeeAllocations: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.loadingFeeAllocations = false;
      state.errorLoadingFeeAllocations = action.payload;
    },
    setErrorCreatingFeeAllocation: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.loadingFeeAllocationCreate = false;
      state.errorCreatingFeeAllocation = action.payload;
    },
    setErrorDeletingFeeAllocation: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.loadingFeeAllocationDelete = false;
      state.errorDeletingFeeAllocation = action.payload;
    },
    setFeeAllocations: (
      state,
      action: PayloadAction<StudentFeeAllocationResponseDto[]>,
    ) => {
      state.loadingFeeAllocations = false;
      state.errorLoadingFeeAllocations = null;
      state.feeAllocations = action.payload;
    },
    createFeeAllocationSuccess: (
      state,
      action: PayloadAction<StudentFeeAllocationResponseDto>,
    ) => {
      state.feeAllocations = [action.payload, ...state.feeAllocations];
      state.loadingFeeAllocationCreate = false;
      state.errorCreatingFeeAllocation = null;
    },
    deleteFeeAllocationSuccess: (state, action: PayloadAction<string>) => {
      state.feeAllocations = state.feeAllocations.filter(
        (a: any) => (a.allocationId || a.id) !== action.payload,
      );
      state.loadingFeeAllocationDelete = false;
      state.errorDeletingFeeAllocation = null;
    },
    setServerResponseStatus: (
      state,
      action: PayloadAction<ServerStatusPayload | null>,
    ) => {
      state.serverStatus = action.payload;
    },
    setPagination: (state, action: PayloadAction<PaginationDto>) => {
      state.pagination = action.payload;
    },
  },
});

export const feeAllocationActions = feeAllocationSlice.actions;
export default feeAllocationSlice.reducer;
